import React from "react";
import TravelForm from "../../components/TravelForm";


export default function Voos() {
    return (
      
          <TravelForm/>      
    );
}